'use es6';

import TypingIndicator from 'conversations-visitor-message-history/typing-indicator/TypingIndicatorMessage';
import AvailabilityMessage from 'conversations-visitor-message-history/availability/AvailabilityMessage';
import ActivelyPublishingMessage from 'conversations-visitor-message-history/publishing/ActivelyPublishingMessage';
import FeedbackSurveyMessage from 'conversations-visitor-message-history/feedback-survey-message/FeedbackSurveyMessage';
import ConnectedEmailCapturePromptMessage from '../containers/connected-messages/ConnectedEmailCapturePromptMessage';
import ConnectedFailedToPublishMessage from '../containers/connected-messages/ConnectedFailedToPublishMessage';
import ConnectedInitialMessage from '../containers/connected-messages/ConnectedInitialMessage';
import ConnectedCommonMessage from '../containers/connected-messages/ConnectedCommonMessage';
import { withConsent } from '../connectors/withConsent';
import ConnectedDateLabel from '../containers/connected-messages/ConnectedDateLabel';
import { supportedMessageTypes } from './supportedMessageTypes';
import { withSessionId } from '../connectors/withSessionId';
import { withHubspotUtk } from '../connectors/withHubspotUtk';
import { withThreadId } from '../connectors/withThreadId';
const {
  ACTIVELY_PUBLISHING,
  COMMON_MESSAGE,
  DATE_MESSAGE,
  EMAIL_CAPTURE_PROMPT,
  FAILED_TO_PUBLISH,
  INITIAL_MESSAGE,
  OFFICE_HOURS,
  TYPICAL_RESPONSE_TIME,
  TYPING,
  FEEDBACK_SURVEY
} = supportedMessageTypes;
export const MessageHistoryConfig = {
  [ACTIVELY_PUBLISHING]: ActivelyPublishingMessage,
  [COMMON_MESSAGE]: withConsent(ConnectedCommonMessage),
  [DATE_MESSAGE]: ConnectedDateLabel,
  [EMAIL_CAPTURE_PROMPT]: ConnectedEmailCapturePromptMessage,
  [FAILED_TO_PUBLISH]: ConnectedFailedToPublishMessage,
  [INITIAL_MESSAGE]: withConsent(ConnectedInitialMessage),
  [OFFICE_HOURS]: AvailabilityMessage,
  [TYPICAL_RESPONSE_TIME]: AvailabilityMessage,
  [TYPING]: TypingIndicator,
  [FEEDBACK_SURVEY]: withThreadId(withSessionId(withHubspotUtk(FeedbackSurveyMessage)))
};